import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { CartProvider } from './context/CartContext';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Orders from './pages/Orders';
import Delivery from './pages/Delivery';
import Customers from './pages/Customers';
import Reports from './pages/Reports';
import Wallet from './pages/Wallet';
import Inventory from './pages/Inventory';

import Settings from './pages/Settings';
import Checkout from './pages/Checkout';
import Subscriptions from './pages/Subscriptions';
import Addresses from './pages/Addresses';
import ResetPassword from './pages/ResetPassword';
import ForgotPassword from './pages/ForgotPassword';
import SetupAccount from './pages/SetupAccount';
import ChangePassword from './pages/ChangePassword';
import DeliveryAgentDashboard from './pages/DeliveryAgent';
import EditProfile from './pages/EditProfile';
import HelpSupport from './pages/HelpSupport';
import Organizations from './pages/Organizations';
import Stores from './pages/Stores';
import Users from './pages/Users';
import PrivateRoute from './components/PrivateRoute';

function App() {
  return (
    <CartProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/setup-account" element={<SetupAccount />} />

            <Route
              path="/change-password"
              element={
                <PrivateRoute>
                  <ChangePassword />
                </PrivateRoute>
              }
            />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/organizations"
              element={
                <PrivateRoute roles={['super_user']}>
                  <Organizations />
                </PrivateRoute>
              }
            />
            <Route
              path="/stores"
              element={
                <PrivateRoute roles={['super_user', 'entity_admin']}>
                  <Stores />
                </PrivateRoute>
              }
            />
            <Route
              path="/users"
              element={
                <PrivateRoute roles={['super_user', 'entity_admin']}>
                  <Users />
                </PrivateRoute>
              }
            />
            <Route
              path="/products"
              element={
                <PrivateRoute roles={['super_user', 'entity_admin', 'admin', 'staff', 'customer']}>
                  <Products />
                </PrivateRoute>
              }
            />
            <Route
              path="/orders"
              element={
                <PrivateRoute>
                  <Orders />
                </PrivateRoute>
              }
            />
            <Route
              path="/subscriptions"
              element={
                <PrivateRoute roles={['super_user', 'entity_admin', 'admin', 'staff', 'customer']}>
                  <Subscriptions />
                </PrivateRoute>
              }
            />
            <Route
              path="/delivery"
              element={
                <PrivateRoute roles={['super_user', 'entity_admin', 'admin', 'staff', 'delivery']}>
                  <Delivery />
                </PrivateRoute>
              }
            />
            <Route
              path="/delivery-agent"
              element={
                <PrivateRoute roles={['delivery']}>
                  <DeliveryAgentDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/customers"
              element={
                <PrivateRoute roles={['super_user', 'entity_admin', 'admin', 'staff']}>
                  <Customers />
                </PrivateRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <PrivateRoute roles={['super_user', 'entity_admin', 'admin', 'staff']}>
                  <Reports />
                </PrivateRoute>
              }
            />
            <Route
              path="/wallet"
              element={
                <PrivateRoute roles={['super_user', 'entity_admin', 'admin', 'staff', 'customer']}>
                  <Wallet />
                </PrivateRoute>
              }
            />
            <Route
              path="/inventory"
              element={
                <PrivateRoute roles={['super_user', 'entity_admin', 'admin', 'staff']}>
                  <Inventory />
                </PrivateRoute>
              }
            />

            <Route
              path="/settings"
              element={
                <PrivateRoute>
                  <Settings />
                </PrivateRoute>
              }
            />
            <Route
              path="/addresses"
              element={
                <PrivateRoute roles={['super_user', 'entity_admin', 'admin', 'staff', 'customer']}>
                  <Addresses />
                </PrivateRoute>
              }
            />
            <Route
              path="/checkout"
              element={
                <PrivateRoute roles={['customer']}>
                  <Checkout />
                </PrivateRoute>
              }
            />
            <Route
              path="/edit-profile"
              element={
                <PrivateRoute>
                  <EditProfile />
                </PrivateRoute>
              }
            />
            <Route
              path="/help"
              element={
                <PrivateRoute>
                  <HelpSupport />
                </PrivateRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" />
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;